export const availableLanguagues = ['ES', 'EN', 'PT', 'DE'];

export const archiverFolder = '000000000000000000000000';

export const undefinedEndDate = '4000-12-12T06:00:00.000Z';

export const nonEditableStatus = ['CANCELED'];

export const statusesMapper = {
    PARA_FONDEAR:
    {
        title: 'TO_FUND',
        icon: 'fa-dollar-sign',
    },
    ESPERANDO_CONFIGURACION_DUENO:
    {
        title: 'WAITING_OWNER_CONFIGURATION',
        icon: 'fa-user-clock',
    },
    ESPERANDO_APROBACION_DUENO:
    {
        title: 'WAITING_OWNER_APPROVAL',
        icon: 'fa-user-clock',
    },
    TOMAR_NEGOCIACION:
    {
        title: 'TAKE_OR_ACCEPT_NEGOTIATION',
        icon: 'fa-hand-sparkles',
    },
    SUBIR_VERSION_NEGOCIACION:
    {
        title: 'NEGOTIATION_TAKEN',
        icon: 'fa-upload',
    },
    ESPERANDO_AL_OTRO_NEGOCIACION_DOCUMENTO:
    {
        title: 'WAITING_TO_NEGOTIATION',
        icon: 'fa-user-clock',
    },
    COMPLETAR:
    {
        title: 'READY_TO_FILL',
        icon: 'fa-tasks',
    },
    ESPERANDO_COMPLETADO:
    {
        title: 'WAITING_TO_FILL',
        icon: 'fa-user-clock',
    },
    ESPERANDO_AL_OTRO:
    {
        title: 'WAITING_TO_NEGOTIATION',
        icon: 'fa-user-clock',
    },
    ACEPTAR:
    {
        title: 'READY_TO_NEGOTIATE',
    },
    REQUIERE_GRABAR_CONSENTIMIENTO:
    {
        title: 'GENERATE_AGREEMENT',
        icon: 'fa-camera',
    },
    ESPERANDO_VALIDACION:
    {
        title: 'WAITING_AGREEMENT_VALIDATION',
        icon: 'fa-user-clock',
    },
    ESPERANDO_VALIDACION_ID:
    {
        title: 'WAITING_ID_VALIDATION',
        icon: 'fa-user-clock',
    },
    REQUIERE_VERIFICAR_IDENTIDAD:
    {
        title: 'MUST_VERIDOC',
        icon: 'fa-user-clock',
    },
    LISTO_PARA_FIRMAR:
    {
        title: 'READY_TO_SIGN',
        icon: 'fa-file-signature',
    },
    NO_ES_MI_TURNO:
    {
        title: 'NOT_YOUR_TURN',
        icon: 'fa-user-clock',
    },
    SUBIR_VERSION:
    {
        title: 'UPLOAD_VERSION',
        icon: 'fa-upload',
    },
    SUBIR_VERSION_WORD:
    {
        title: 'UPLOAD_VERSION',
        icon: 'fa-upload',
    },
    DESCARGAR:
    {
        title: 'DOWNLOAD',
        icon: 'fa-download',
    },
    FIRMADO:
    {
        title: 'NOT_YOUR_TURN',
        icon: 'fa-check',
    }
}

export const SCREEN_OPTIONS = {
    PAGARE_TUTORIAL: 'PAGARE_TUTORIAL',
    CONFIDENTIAL_ATTACHMENTS_TUTORIAL: 'CONFIDENTIAL_ATTACHMENTS_TUTORIAL',
    UPLOAD_DOWNLOAD_VERSION_TUTORIAL: 'UPLOAD_DOWNLOAD_VERSION_TUTORIAL',
    COMMENTS_TUTORIAL: 'COMMENTS_TUTORIAL',
    NEGOTIATE_OR_SIGN_TUTORIAL: 'NEGOTIATE_OR_SIGN_TUTORIAL',
    SIGN_TUTORIAL: 'SIGN_TUTORIAL',
    HELP_TUTORIAL: 'HELP_TUTORIAL',
}

export const Tabs = [
    'negotiation_tab',
    'complete_tab',
    'annexes_tab',
    'sharedocs_tab',
    'blockchain_tab'
]